export const getNextLevelUrl = (level: number) => {
  const nextLevel: { [level: number]: string } = {
    1: '/second',
    2: '/third',
    3: '/fourth',
    4: '/fifth',
    5: '/sixth',
    6: '/seventh',
    7: '/eighth',
    8: '/ninth',
    9: '/tenth',
    10: '/eleventh',
    11: '/twelfth',
  }

  console.log("Getting next level url for level ", level, ": ", nextLevel[level]);

  return nextLevel[level];
}

export function isLevelAllowed(level: number) {
  console.log("Checking if level ", level, " is allowed. Progress: ", localStorage.getItem("LEVELS_COMPLETED"));
  
  const progress: string | null = localStorage.getItem("LEVELS_COMPLETED");

  if (progress) {
    const levelsCompleted: number[] = JSON.parse(progress);
    
    if (levelsCompleted.indexOf(level - 1) > -1) {
      console.log("Level ", level, " is allowed");
      return true;
    } else {
      console.log("Level ", level, " is NOT allowed");
      return false;
    }
  }
  
  console.log("No progress found, level ", level, " is NOT allowed");
  return false;
}

export function markLevelCompleted(level: number) {
  const progress: string | null = localStorage.getItem("LEVELS_COMPLETED");

  if (progress) {
    const levelsCompleted: number[] = JSON.parse(progress);
    if (levelsCompleted.indexOf(level) === -1) {
      localStorage.setItem("LEVELS_COMPLETED", JSON.stringify([...levelsCompleted, level]))
    }
  } else {
    localStorage.setItem("LEVELS_COMPLETED", JSON.stringify([level]));
  }
  
  console.log("Marked level ", level, " as completed. New progress: ", localStorage.getItem("LEVELS_COMPLETED"));
}